// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"lX-z","sponsoredTooltipWrapper":"mX-z","sponsoredTooltip":"nX-z","newCard":"oX-z"};